import { createFileRoute, Link, notFound } from "@tanstack/react-router";

import { HubPlacePage, hubPlaceQuery } from "@/components/hubs/HubPlacePage";
import { hubPlaceHead } from "@/lib/hub-seo";

export const Route = createFileRoute("/cafes/$slug")({
  loader: async ({ params, context }) => {
    const data = await context.queryClient.ensureQueryData(hubPlaceQuery("cafes", params.slug));
    if (!data) throw notFound();
    return data;
  },
  head: ({ params, loaderData }) =>
    hubPlaceHead({ path: `/cafes/${params.slug}`, locale: "en", loaderData }),
  component: CafesPlaceRoute,
  notFoundComponent: () => (
    <div className="flex min-h-screen items-center justify-center p-8 text-center">
      <div>
        <h1 className="font-heading text-2xl">Café not available</h1>
        <Link to="/cafes" className="mt-6 inline-block text-royal underline">
          Browse all cafes
        </Link>
      </div>
    </div>
  ),
});

function CafesPlaceRoute() {
  const { slug } = Route.useParams();
  return <HubPlacePage hubSlug="cafes" placeSlug={slug} locale="en" />;
}
